import { useCallback, useEffect, useState } from "react";
import { fetchApplications, fetchIntakes } from "./commissionsApi";

const DEFAULT_PAGINATION = {
  currentPage: 1,
  perPage: 25,
  total: 0,
  lastPage: 1,
};

export function useCommissionsData(applied) {
  const [loading, setLoading] = useState(false);
  const [applications, setApplications] = useState([]);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [intakes, setIntakes] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [viewCounts, setViewCounts] = useState(null);

  useEffect(() => {
    fetchIntakes().then(setIntakes).catch(console.error);
  }, []);

  const loadApplications = useCallback(async () => {
    if (applied?.report === "inquiry_batches") {
      setApplications([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const result = await fetchApplications(applied, pagination);
      setApplications(result.data);
      setViewCounts(result.raw?.counts ?? null);
      setPagination((prev) => ({
        ...prev,
        total: result.pagination?.total ?? 0,
        lastPage: result.pagination?.lastPage ?? 1,
        currentPage: result.pagination?.currentPage ?? prev.currentPage,
      }));
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  }, [applied, pagination.currentPage, pagination.perPage]);

  useEffect(() => {
    loadApplications();
  }, [loadApplications]);

  const handlePageChange = useCallback((selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  }, []);

  const handlePerPageChange = useCallback((perPage) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(perPage, 10),
      currentPage: 1,
    }));
  }, []);

  const resetPagination = useCallback(() => {
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  }, []);

  return {
    loading,
    applications,
    pagination,
    intakes,
    lastUpdated,
    viewCounts,
    handlePageChange,
    handlePerPageChange,
    resetPagination,
    setPagination,
    refetch: loadApplications,
  };
}
